import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { CustomLinkComponent, Spinner } from 'msp-components'
import * as T from './ActionCard.types'

const ActionCard = ({
  className,
  children,
  onEdit,
  onRemove,
  noSpinner = false,
  otherActionsPostion = 'after',
  otherActions = []
}: T.ActionCardProps) => {
  const [showLoading, setShowLoading] = useState(false)
  const { formatMessage } = useIntl()

  const handleRemove = async () => {
    if (onRemove && !showLoading) {
      setShowLoading(!showLoading)
      try {
        await Promise.resolve(onRemove())
        setShowLoading(false)
      } catch (err) {
        setShowLoading(false)
        throw err
      }
    }
  }

  const renderOtherActions = () => {
    return (
      otherActions &&
      otherActions.length > 0 &&
      otherActions.map(
        (otherAction: T.ActionCardOtherActionProps, index: number) => {
          return (
            otherAction?.label &&
            otherAction?.actionHandler && (
              <div
                onClick={() => !showLoading && otherAction.actionHandler()}
                key={`card-other-actions-${otherAction.id || index}`}
              >
                <CustomLinkComponent
                  className={`text-machine2-100 text-12 capitalize underline-offset-4 hover:underline ${
                    otherAction.className || ''
                  } ${
                    showLoading && 'text-gray94 cursor-not-allowed no-underline'
                  }`}
                  inline={true}
                >
                  {formatMessage(otherAction.label)}
                </CustomLinkComponent>
              </div>
            )
          )
        }
      )
    )
  }

  return (
    <div className={className}>
      {showLoading && !noSpinner && <Spinner />}
      <div className={'flex flex-col space-y-3'}>
        <div>{children}</div>
        <div className={'flex flex-row space-x-4'}>
          {otherActionsPostion === 'before' && renderOtherActions()}
          {onEdit && (
            <div onClick={() => !showLoading && onEdit()}>
              <CustomLinkComponent
                className={`text-12 capitalize text-black underline-offset-4 hover:underline ${
                  showLoading && 'text-gray94 cursor-not-allowed'
                }`}
                inline={true}
              >
                <FormattedMessage
                  defaultMessage='Edit'
                  id='action_card.action.edit'
                />
              </CustomLinkComponent>
            </div>
          )}
          {otherActionsPostion === 'center' && renderOtherActions()}
          {onRemove && (
            <div onClick={handleRemove}>
              <CustomLinkComponent
                className={`text-errorRed text-12 capitalize underline-offset-4 hover:underline ${
                  showLoading && 'text-gray94 cursor-not-allowed'
                }`}
                inline={true}
              >
                <FormattedMessage
                  defaultMessage='Remove'
                  id='action_card.action.remove'
                />
              </CustomLinkComponent>
            </div>
          )}
          {otherActionsPostion === 'after' && renderOtherActions()}
        </div>
      </div>
    </div>
  )
}

export default ActionCard
